<template>
    <div id="app">
        <router-view />
    </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import LoadingMixin from '@/plugins/Common/LoadingMixin.js'

export default {
    name: "App",
    mixins: [LoadingMixin],
    beforeCreate() {
        this.$store.dispatch('cart/loadCart')
        this.$store.dispatch('general/loadInfo')
        this.$store.dispatch('general/loadFilters')
        .then(res => {
            // this.changeTitle(res.name)
            // this.changeFavicon(this.$utilities.publicPath(res.store_logo))
        })

    },
    mounted: function () {

    },
    computed: {
        ...mapGetters({
            company: "general/allInfo",
        }),
    },
    watch: {
        'company.store_logo': {
            immediate: true,
            handler(storeLogo) {
                this.updateFavicon(storeLogo);
            },
        },
    },
    methods: {
        getFaviconPath(storeLogo) {
            if (!storeLogo) return null;

            if (/^(https?:)?\/\//i.test(storeLogo) || storeLogo.startsWith('data:')) {
                return storeLogo;
            }

            return this.getMediaPath(storeLogo);
        },
        getFaviconType(faviconPath) {
            const cleanPath = faviconPath.split('?')[0].toLowerCase();

            if (cleanPath.endsWith('.png')) return 'image/png';
            if (cleanPath.endsWith('.jpg') || cleanPath.endsWith('.jpeg')) return 'image/jpeg';
            if (cleanPath.endsWith('.svg')) return 'image/svg+xml';
            if (cleanPath.endsWith('.webp')) return 'image/webp';
            if (cleanPath.endsWith('.ico')) return 'image/x-icon';

            return null;
        },
        updateFavicon(storeLogo) {
            const faviconPath = this.getFaviconPath(storeLogo);

            if (!faviconPath) return;

            document.querySelectorAll('link[rel~="icon"]').forEach((iconLink) => {
                if (iconLink.id !== 'dynamic-favicon') {
                    iconLink.parentNode.removeChild(iconLink);
                }
            });

            const favicon = document.getElementById('dynamic-favicon') || document.createElement('link');
            const faviconType = this.getFaviconType(faviconPath);

            favicon.id = 'dynamic-favicon';
            favicon.rel = 'shortcut icon';
            favicon.href = faviconPath;

            if (faviconType) {
                favicon.type = faviconType;
            } else {
                favicon.removeAttribute('type');
            }

            if (favicon.parentNode) {
                favicon.parentNode.removeChild(favicon);
            }

            document.head.appendChild(favicon);
        },
    },
    metaInfo() {
        return {
            title: this.company.business_name ? this.company.business_name : '',
            titleTemplate: `%s - ${this.company.description ? this.company.description : ''}`,
            htmlAttrs: {
                lang: "es",
            },
            meta: [
                { charset: "utf-8" },
                {
                    name: "viewport",
                    content: "width=device-width, initial-scale=1",
                },
                {
                    hid: "description",
                    name: "description",
                    content: this.company.description ? this.company.description : '',
                },
            ],
        };
    },
};
</script>
